import { setActiveAction} from '@process-advisor/process-miner/processMiner/processMiner'
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {}

export const setAction_Visualizer = ({ eventEmitter }: Props) => {
    setActiveAction('process_miner')
    eventEmitter.emit(Event.setActionBar_Visualizer, { findingID: null, source: 'process_miner' });
    eventEmitter.emit(Event.setDiagramWidth, { findingID: null });
};
    